import { render } from "./notifications.vue?vue&type=template&id=b7f719ca&scoped=true"
import script from "./notifications.vue?vue&type=script&lang=js"
export * from "./notifications.vue?vue&type=script&lang=js"

import "./notifications.vue?vue&type=style&index=0&id=b7f719ca&scoped=true&lang=css"

import exportComponent from "/var/www/EasternFront_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7f719ca"]])

export default __exports__